import { parseDate } from '@luna/date';

export function parseOptionalDate(
    ...[date, ...params]: Parameters<typeof parseDate>
): ReturnType<typeof parseDate> | undefined {
    if (date === undefined || date === null || date === '') {
        return undefined;
    }

    return parseDate(date, ...params);
}
